import * as React from 'react';
import { Link } from 'react-router-dom';
import Test from 'src/entities/AptitudeTest';
import MyAccountHeaderComponent from 'src/modules/my-account/partials/MyAccountHeader.component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface TestInvestorTypeComponentProps {
  test: Test;
  handleChange: (section: number, question: number, choice: number) => void;
  handleSubmit: () => void;
  error: boolean;
  errorMessage: {};
  success: boolean;
}

class TestInvestorTypeComponent extends React.Component<TestInvestorTypeComponentProps> {

  public render(): React.ReactNode {

    return (
      <section className="cuenta-inversor-section">
        <div className="container">
          <MyAccountHeaderComponent
            pageTitle="Tipo de inversor"
            breadcrum="Tipo de inversor"
          />
          <div className="row">
            <div className="col-sm-12">
              <div className="simple-card padding-40">
                <section>
                  <Link to="/mi-cuenta/tipo-de-inversor">
                    <span className="close pointer"/>
                  </Link>
                  <div className="gap-20"/>
                  <h4>
                    Test de Idoneidad
                  </h4>
                  <div className="gap-20"/>
                  {this.props.test.sections.map(
                    (section, index) => (
                      <section key={index}>
                        <p className="padding-l-90 f-s-18">
                          <strong className="f-s-22 num">
                            {String.fromCharCode(97 + index).toUpperCase()}. -
                          </strong>
                          <strong>
                            {section.title}
                          </strong>
                        </p>
                        {section.questions.map(
                          (question, qIndex) => (
                            <section key={qIndex}>
                              <p className="padding-l-160">
                                {question.statement}
                              </p>
                              <form className="padding-l-160">
                                {question.choices.map(
                                  (choice, cIndex) => (
                                    <div
                                      className="radio"
                                      key={cIndex}
                                    >
                                      <input
                                        type="radio"
                                        id={'option' + choice.id}
                                        name="optradio"
                                        onChange={() => this.props.handleChange(section.id, question.id, choice.id)}
                                      />
                                      <label htmlFor={'option' + choice.id}>
                                        {choice.text}
                                      </label>
                                    </div>
                                  )
                                )}
                              </form>
                            </section>
                          )
                        )}
                      </section>
                    )
                  )}
                  <div className="gap-20"/>
                  <ErrorMessagesComponent
                    errorMessage={this.props.errorMessage}
                  />
                  <div className="gap-20"/>
                  <p className="text-center">
                    <button
                      className="btn btn-secondary btn-lg"
                      onClick={() => this.props.handleSubmit()}
                    >
                      Enviar test
                    </button>
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TestInvestorTypeComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/aptitude-test/AptitudeTestInvestorType.component.tsx